/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export enum GuardianConnectionTrunkType {
    Switched = 'switched',
    Dedicated = 'dedicated',
}